// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"34912689","161":"fbf804a7","164":"64fefca9","647":"c5d83a16","833":"fe6b9181","837":"fb7cd29d","890":"31f9bb36","909":"6ce138be","982":"06aec021","991":"358a3995"}[chunkId] + ".chunk.js";
};